module.exports = __webpack_public_path__ + "static/media/iiitk_logo.571a8584.png";